import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { COMPANY, SERVICES } from "@/lib/constants";
import { Logo } from "@/components/site/Logo";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            className="relative border-t border-white/[0.08] bg-[#07090C] mt-16"
            data-testid="footer"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
                    <div className="md:col-span-1">
                        <Logo />
                        <p className="mt-4 text-sm text-[#8FA0B8] leading-relaxed max-w-xs">
                            Premium Reinigungsservice in Innsbruck und ganz Tirol.
                            Sauberkeit. Qualität. Zuverlässigkeit.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-sm font-semibold text-white mb-4 font-heading">
                            Leistungen
                        </h3>
                        <ul className="space-y-2">
                            {SERVICES.map((s) => (
                                <li key={s.slug}>
                                    <Link
                                        to={`/leistungen/${s.slug}`}
                                        className="text-sm text-[#C9D3E1] hover:text-white transition-colors"
                                    >
                                        {s.title}
                                    </Link>
                                </li>
                            ))}
                            <li className="pt-1">
                                <Link
                                    to="/leistungen"
                                    className="text-sm text-[#7BD3FF] hover:text-white transition-colors"
                                >
                                    Alle Leistungen →
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-sm font-semibold text-white mb-4 font-heading">
                            Kontakt
                        </h3>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href={`tel:${COMPANY.phoneTel}`}
                                    className="flex items-center gap-2 text-[#C9D3E1] hover:text-white transition-colors"
                                    data-testid="footer-call-link"
                                >
                                    <Phone className="h-4 w-4 text-[#2EA8FF]" />
                                    <span className="font-mono">{COMPANY.phone}</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${COMPANY.email}`}
                                    className="flex items-center gap-2 text-[#C9D3E1] hover:text-white transition-colors"
                                    data-testid="footer-email-link"
                                >
                                    <Mail className="h-4 w-4 text-[#2EA8FF]" />
                                    {COMPANY.email}
                                </a>
                            </li>
                            <li className="flex items-start gap-2 text-[#C9D3E1]">
                                <MapPin className="h-4 w-4 text-[#2EA8FF] mt-0.5" />
                                <span>
                                    {COMPANY.address.street}
                                    <br />
                                    {COMPANY.address.city}
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-sm font-semibold text-white mb-4 font-heading">
                            Rechtliches
                        </h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/impressum"
                                    className="text-[#C9D3E1] hover:text-white transition-colors"
                                    data-testid="footer-impressum-link"
                                >
                                    Impressum
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/datenschutz"
                                    className="text-[#C9D3E1] hover:text-white transition-colors"
                                    data-testid="footer-datenschutz-link"
                                >
                                    Datenschutz
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/cookie-policy"
                                    className="text-[#C9D3E1] hover:text-white transition-colors"
                                    data-testid="footer-cookie-policy-link"
                                >
                                    Cookie-Policy
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="shimmer-divider my-10" />

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <p className="text-xs text-[#8FA0B8]">
                        © {year} {COMPANY.legalName}. Alle Rechte vorbehalten.
                    </p>
                    <p className="text-xs text-[#8FA0B8] font-mono">
                        {COMPANY.atu} · St-Nr. {COMPANY.stNr} · DG-Nr. {COMPANY.dgNr}
                    </p>
                </div>
            </div>
        </footer>
    );
}
